module.exports = __webpack_public_path__ + "static/img/1010_big.3570505.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1010_big.png
// module id = NNBP
// module chunks = 1